import React from 'react';
//import Sidebar from './component/Sidebar';
import Login from "./pages/Login";
import Report from "./pages/Report";
import CompanyProfile from "./pages/CompanyProfile";
import ComplianceReports from "./pages/ComplianceReports";
import ChartReportsPage from "./pages/ChartReportsPage";


import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import '../node_modules/font-awesome/css/font-awesome.min.css'; 

import "./css/style.css";

import $ from "jquery";
import FullChartsPage from './pages/FullChartsPage';

const App = () => {
  
    console.log(window.location.pathname);
    return(
        <Router basename='/final-nova-charts'> 
         {/* {window.location.pathname !== '/nova' && <Sidebar />}
        <Sidebar/> */}
            <Routes> 
                <Route path="/" element={<Login />} />
                <Route path="/report" element={<Report />} />
                <Route path="/compliance-reports" element={<ComplianceReports />} />
                <Route path="/company-profile" element={<CompanyProfile />} />
                <Route path="/chart-reports" element={<ChartReportsPage />} />
                <Route path="/full-charts" element={<FullChartsPage/>} />
            </Routes>        
        </Router>          
    );
};

export default App;